import { useEffect, useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { sectionVariants } from "./variants";

const MotionSection = ({ children, className = "", as = "section", ...props }) => {
	const shouldReduceMotion = useReducedMotion();
	const ref = useRef(null);
	const [isVisible, setIsVisible] = useState(false);
	const Component = motion[as] || motion.section;

	useEffect(() => {
		if (shouldReduceMotion || isVisible) {
			return undefined;
		}

		const element = ref.current;
		if (!element || !("IntersectionObserver" in window)) {
			setIsVisible(true);
			return undefined;
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.18 }
		);

		observer.observe(element);

		return () => observer.disconnect();
	}, [isVisible, shouldReduceMotion]);

	if (shouldReduceMotion) {
		const StaticComponent = as;
		return (
			<StaticComponent className={className} ref={ref} {...props}>
				{children}
			</StaticComponent>
		);
	}

	return (
		<Component
			ref={ref}
			className={className}
			variants={sectionVariants}
			initial="hidden"
			animate={isVisible ? "visible" : "hidden"}
			{...props}
		>
			{children}
		</Component>
	);
};

export default MotionSection;
